import { FC, HTMLAttributes, ReactNode, useEffect, useState } from 'react';
import FontAwesomeIcon from '../font-awesome-icon/font-awesome-icon';
import './link-button.scss';
import classNames from '../../utils/classnames';
import { LINK_THEMES } from '../../constants/link-themes';
import DomainSensitiveLink from '../domain-sensitive-link/domain-sensitive-link';

type LinkButtonProps = HTMLAttributes<HTMLButtonElement> & {
    text: string | ReactNode;
    arrow?: boolean;
    className?: string;
    disabled?: boolean;
    href?: string;
    less?: boolean;
    more?: boolean;
    theme?: '' | 'black' | 'green';
};

const LinkButton: FC<LinkButtonProps> = ({
    href,
    theme = '',
    text = '',
    className = '',
    less = false,
    more = false,
    arrow = false,
    disabled = false,
    ...props
}) => {
    const [currentTheme, setCurrentTheme] = useState(() => theme);

    const content = (
        <button
            className={classNames(`link-button ${className} ${theme}`)}
            disabled={disabled}
            onMouseEnter={() => setCurrentTheme(theme === LINK_THEMES.TINY ? LINK_THEMES.TINY : LINK_THEMES.GREEN)}
            onMouseLeave={() => setCurrentTheme(theme)}
            {...props}
        >
            {more && <FontAwesomeIcon name='plus' theme={currentTheme} />}
            {less && <FontAwesomeIcon height={2} name='minus' theme={currentTheme} />}
            <span className={classNames({ 'ml-2': more || less, 'mr-2': arrow })}>{text}</span>
            {arrow && <FontAwesomeIcon height={12} name='arrow-right' theme={currentTheme} />}
        </button>
    );

    useEffect(() => {
        setCurrentTheme(theme);
    }, [theme]);

    return href ? <DomainSensitiveLink href={href}>{content}</DomainSensitiveLink> : content;
};

export default LinkButton;
